export const FETCH_RENTAL_GROUPS = '@@rentalGroups/fetch-rentalGroups';
export const FETCH_RENTAL_GROUPS_SUCCESS = '@@rentalGroups/fetch-rentalGroups-success';
export const FETCH_RENTAL_GROUPS_FAILURE = '@@rentalGroups/fetch-rentalGroups-failure';
